//
//
//
//
//
//
//
//
//
//
//

import ColorsMixin from '@/mixins/colors.mixin';
export default {
  name: 'TwinMapMarkerColorPickerMenu',
  mixins: [ColorsMixin],
  props: {
    value: {
      type: String,
      required: false,
      "default": null
    }
  },
  data: function data() {
    return {
      colorPickerMenu: false,
      menuX: 0,
      menuY: 0
    };
  },
  computed: {
    colorForActivator: function colorForActivator() {
      return this.value || this.colors[0].value;
    }
  },
  methods: {
    openMenu: function openMenu(e) {
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.colorPickerMenu = true;
    }
  }
};